import { useField } from 'formik';
import { useCallback, useMemo } from 'react';

import type { TextAreaInputProps } from '@types';

import { TextAreaInput } from '.';

export const StringArrayTextAreaInput: React.FC<TextAreaInputProps> = ({ name, value, ...rest }) => {
  const [field, _meta, helpers] = useField(name);

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement>) => {
      const textValue = event.target.value;
      const splitValue = textValue.split('\n').map((item) => item.trim());
      helpers.setValue(splitValue);
    },
    [helpers],
  );

  const handleBlur = useCallback(
    (event: React.FocusEvent<HTMLTextAreaElement>) => {
      const textValue = event.target.value;
      const splitValue = textValue
        .split('\n')
        .map((item) => item.trim())
        .filter((item) => item !== '');

      helpers.setValue(splitValue);
      field.onBlur(event);
    },
    [helpers, field.onBlur],
  );

  const displayValue = useMemo(() => {
    if (Array.isArray(field.value)) {
      return field.value.join('\n');
    }

    return field.value ?? '';
  }, [field.value]);

  return <TextAreaInput {...rest} name={name} value={displayValue} onChange={handleChange} onBlur={handleBlur} />;
};
